_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[31],{

/***/ "CN/t":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/write-review",
      function () {
        return __webpack_require__("NV40");
      }
    ]);
  

/***/ }),

/***/ "NV40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("cIxt");
/* harmony import */ var _grandvision_reviews__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("NA/S");
/* harmony import */ var _util_feature_toggle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ns9e");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_3___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var selfUrl = publicRuntimeConfig.selfUrl || '';
var _publicRuntimeConfig$ = publicRuntimeConfig.powerReviews,
    powerReviewsApiKey = _publicRuntimeConfig$.apiKey,
    groupId = _publicRuntimeConfig$.groupId,
    opcoId = _publicRuntimeConfig$.opcoId;

var WriteReviewPage = function WriteReviewPage() {
  var _useBloomreachPageRou = Object(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_4__[/* useBloomreachPageRoutes */ "n"])(),
      routes = _useBloomreachPageRou.routes;

  var reviewsProviderProps = react__WEBPACK_IMPORTED_MODULE_2__["useMemo"](function () {
    return {
      enabled: Object(_util_feature_toggle__WEBPACK_IMPORTED_MODULE_6__[/* isReviewsEnabled */ "l"])(),
      config: {
        groupId: groupId,
        opcoId: opcoId,
        apiKey: powerReviewsApiKey,
        writeReviewPath: routes['write-review']
      }
    };
  }, // other fields are static during runtime
  [routes]);
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_4__[/* CmsContainerPage */ "d"], {
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsxs"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_4__[/* CmsPageLayout */ "g"], {
      children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_4__[/* CmsComponentSlot */ "c"], {
        path: "main/top-container"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_5__[/* ReviewsProvider */ "e"], _objectSpread(_objectSpread({}, reviewsProviderProps), {}, {
        children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_reviews__WEBPACK_IMPORTED_MODULE_5__[/* ReviewWrite */ "d"], {
          selfUrl: selfUrl
        })
      })), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_4__[/* CmsComponentSlot */ "c"], {
        path: "main/bottom-container"
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (WriteReviewPage);

/***/ }),

/***/ "mOvS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("yLiY")


/***/ }),

/***/ "ns9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAABEnabled; });
/* unused harmony export isABTestingEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAddressBookEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMyAccountEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isContactLensEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isContactLensStockEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCrossSellEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isReviewsEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSolutionsEnabled; });
/* unused harmony export isSearchEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isVtoEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isGPSEnabled; });
/* unused harmony export isPlacePredictionsEnabled */
/* unused harmony export isMultilingualEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isPrescriptionGlassesEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isPrescriptionGlassesConfiguratorValidationStepEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPrescriptionFileEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isStoreSearchEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isSubscriptionHasOneAddressEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isSubscriptionUpdateAddressEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCartV2Enabled; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/**
 * This exposes functions that will return true when a feature toggle has been set.
 * It will work both on the server and client
 *
 * To enable a feature:
 *
 *  1) Find the feature name in the `Feature` type below, for instance 'MYACCOUNT'
 *  2) Set an env var using the FEATURE_ prefix when starting the server, ie FEATURE_MYACCOUNT
 *  3) Run the app with `FEATURE_MYACCOUNT=true yarn serve` in dev mode or you can add it the .env file
 *
 * To add a feature toggle
 *
 *  1) Add a name to the Feature type, AWESOME_SAUCE for example,
 *      ex: `| 'AWESOME_SAUCE'`
 *  2) Export a function named isAwesomeSauceEnabled
 *      ex: `export const isAwesomeSauceEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'AWESOME_SAUCE')`
 *  3) To enable it see above
 */

var enabledFeatures;

var getEnabledFeatures = function getEnabledFeatures() {
  if (!enabledFeatures) {
    enabledFeatures = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig.grandvision.features;

    if (false) {}
  }

  return enabledFeatures;
};

var isFeatureEnabled = function isFeatureEnabled(feature) {
  return getEnabledFeatures().some(function (e) {
    return e.toUpperCase() === feature.toUpperCase();
  });
};

var isAABEnabled = isFeatureEnabled.bind(null, 'AAB');
var isABTestingEnabled = isFeatureEnabled.bind(null, 'ABTESTING');
var isAddressBookEnabled = isFeatureEnabled.bind(null, 'ADDRESSBOOK');
var isMyAccountEnabled = isFeatureEnabled.bind(null, 'MYACCOUNT');
var isContactLensEnabled = isFeatureEnabled.bind(null, 'CONTACTLENS');
var isContactLensStockEnabled = isFeatureEnabled.bind(null, 'CONTACTLENS_STOCK');
var isCrossSellEnabled = isFeatureEnabled.bind(null, 'CROSS_SELL');
var isReviewsEnabled = isFeatureEnabled.bind(null, 'REVIEWS');
var isSolutionsEnabled = isFeatureEnabled.bind(null, 'SOLUTIONS');
var isSearchEnabled = isFeatureEnabled.bind(null, 'SEARCH');
var isVtoEnabled = isFeatureEnabled.bind(null, 'VTO');
var isGPSEnabled = isFeatureEnabled.bind(null, 'GPS_STORES');
var isPlacePredictionsEnabled = isFeatureEnabled.bind(null, 'STORES_PLACE_PREDICTIONS');
var isMultilingualEnabled = isFeatureEnabled.bind(null, 'MULTILINGUAL');
var isPrescriptionGlassesEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_GLASSES');
var isPrescriptionGlassesConfiguratorValidationStepEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_GLASSES_CONFIGURATOR_VALIDATION_STEP');
var isPrescriptionFileEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_FILE');
var isStoreSearchEnabled = isFeatureEnabled.bind(null, 'STORE_SEARCH');
var isSubscriptionHasOneAddressEnabled = isFeatureEnabled.bind(null, 'SUBSCRIPTION_HAS_ONE_ADDRESS');
var isSubscriptionUpdateAddressEnabled = isFeatureEnabled.bind(null, 'SUBSCRIPTION_UPDATE_ADDRESS');
var isCartV2Enabled = isFeatureEnabled.bind(null, 'CART_V2');

/***/ }),

/***/ "yLiY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setConfig = setConfig;
exports.default = void 0;
var runtimeConfig;

var _default = function _default() {
  return runtimeConfig;
};

exports.default = _default;

function setConfig(configValue) {
  runtimeConfig = configValue;
}

/***/ })

},[["CN/t",1,2,4,6,5,3,0]]]);